const facade = (() => {
  const map = new Map();

  const addListener = (key: string, func: Function) => {
    if (!map.has(key)) {
      map.set(key, []);
    }
    map.get(key).push(func);
  };

  const fireListener = (key: string, prop: any) => {
    if (map.has(key)) {
      map.get(key).forEach((func: Function) => {
        func(prop);
      });
    }
  };

  const killListener = (key: string, func: Function) => {
    if (map.has(key)) {
      let list = map.get(key);
      list = list.slice(list.indexOf(func), 1);
      map.set(key, list);
    }
  };

  return {
    add: addListener,
    fire: fireListener,
    kill: killListener,
  };
})();

export default facade;
